<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import __SearchFormTabs, {SearchFormTabs as _SearchFormTabs} from '@/components/SearchFormTabs.vue'

    @Component({
        mixins: [__SearchFormTabs],
    })
    export class SearchFormTabs extends _SearchFormTabs {}

    export default SearchFormTabs
</script>

<style scoped lang="scss">
    // Apply ZSH theme styling to the search form tabs
    :deep(.search-tabs-wrapper) {
        background-color: transparent !important;
        box-shadow: none !important;
    }

    :deep(.search-tabs > div) {
        border-radius: 16px !important;
    }

    :deep(.search-tabs > div:first-child) {
        margin-bottom: 16px;
    }

    // Style the tabs
    :deep(.v-tabs) {
        background-color: var(--zsh-primary-dark) !important;
    }

    :deep(.v-tab) {
        color: white !important;
    }

    :deep(.v-tab--selected) {
        color: var(--zsh-primary-light) !important;
    }

    :deep(.v-tab .v-icon) {
        color: inherit;
    }

    // Style the content area
    :deep(.v-tabs-window .v-card) {
        background-color: var(--zsh-primary-dark) !important;
        color: white !important;
    }

    :deep(.v-tabs-window .v-btn.bg-primary) {
        background-color: var(--zsh-secondary) !important;
    }
</style>
